// components/ForestPlotCard.js
import React from 'react';
import { Card } from 'react-bootstrap';
import { Download } from 'react-bootstrap-icons'; // optional, can use another icon lib

function ForestPlotCard({ plotUrl }) {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = plotUrl;
    link.download = "forest_plot.png";
    link.click();
  };

  return (
<Card className="p-4 pb-2 shadow-sm rounded-4 mt-4">
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h4 className="mb-0">Generated Forest Plot</h4>
    <button
      onClick={handleDownload}
      className="btn btn-outline-secondary"
      title="Download forest_plot.png"
    >
      <Download className="me-2" />
      Download
    </button>
  </div>

  <div className="d-flex justify-content-center mb-2">
    <img
      src={plotUrl}
      alt="Forest Plot"
      style={{ maxWidth: "100%", height: "auto", borderRadius: "0.5rem" }}
    />
  </div>
</Card>

  );
}

export default ForestPlotCard;
